"use client";

import { c as _c } from "react/compiler-runtime";
import { useRef, useEffect } from "react";
import { useChatContext } from "./chat-provider";
import { ChatMessage } from "./chat-message";
import { ChatInput } from "./chat-input";
import { ChatSessionTabs } from "./chat-session-tabs";
import { ChatTypingIndicator } from "./chat-typing-indicator";
import { useTranslations } from "next-intl";
import { ScrollArea } from "@/components/ui/scroll-area";
import { motion, AnimatePresence } from "motion/react";
import { X } from "lucide-react";
export function ChatWidgetPanel() {
  const $ = _c(19);
  const t = useTranslations("chat.widget");
  const {
    isOpen,
    setIsOpen,
    messages,
    isAdminOnline,
    isAdminTyping,
    visitorSessions,
    sendMessage,
    emitTyping
  } = useChatContext();
  const scrollRef = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const viewport = scrollRef.current?.querySelector("[data-radix-scroll-area-viewport]");
      if (viewport) {
        viewport.scrollTop = viewport.scrollHeight;
      }
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== isAdminTyping || $[2] !== messages) {
    t1 = [messages, isAdminTyping];
    $[1] = isAdminTyping;
    $[2] = messages;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  useEffect(t0, t1);
  let t2;
  let t3;
  if ($[4] !== isOpen) {
    t2 = () => {
      if (!isOpen) {
        return;
      }
      const mq = window.matchMedia("(max-width: 639px)");
      if (!mq.matches) {
        return;
      }
      document.body.style.overflow = "hidden";
      return _temp;
    };
    t3 = [isOpen];
    $[4] = isOpen;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  useEffect(t2, t3);
  let t4;
  if ($[7] !== emitTyping || $[8] !== isAdminOnline || $[9] !== isAdminTyping || $[10] !== isOpen || $[11] !== messages || $[12] !== sendMessage || $[13] !== setIsOpen || $[14] !== t || $[15] !== visitorSessions) {
    t4 = isOpen && <><motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 bg-black/60 sm:hidden" onClick={() => setIsOpen(false)} /><motion.div initial={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} transition={{
        duration: 0.2
      }} className={cn("fixed z-50 flex flex-col overflow-hidden bg-card", "inset-0 pt-[env(safe-area-inset-top)] pb-[env(safe-area-inset-bottom)]", "sm:inset-auto sm:bottom-24 sm:right-6 sm:h-120 sm:w-96 sm:rounded-2xl sm:border sm:shadow-2xl sm:pt-0 sm:pb-0")}><div className="flex items-center gap-3 bg-accent px-4 py-3 text-accent-foreground"><div className="flex h-10 w-10 items-center justify-center rounded-full bg-accent-foreground/20 font-bold">A</div><div className="flex-1"><div className="text-sm font-semibold">Alain</div><div className="flex items-center gap-1 text-xs opacity-80"><span className={cn("h-2 w-2 rounded-full", isAdminOnline ? "bg-green-400" : "bg-gray-300")} />{isAdminOnline ? t("online") : t("offline")}</div></div><button onClick={() => setIsOpen(false)} className="flex h-8 w-8 items-center justify-center rounded-full bg-accent-foreground/20 sm:hidden" aria-label={t("closeChat")}><X className="h-4 w-4" /></button></div>{visitorSessions.length > 1 && <ChatSessionTabs />}<ScrollArea className="flex-1 p-4" ref={scrollRef}>{messages.length === 0 ? <div className="flex items-center justify-center py-8"><p className="text-xs text-muted-foreground">{t("noMessages")}</p></div> : <div className="space-y-3">{messages.map(_temp2)}{isAdminTyping && <ChatTypingIndicator />}</div>}</ScrollArea><ChatInput onSend={sendMessage} onTyping={emitTyping} placeholder={t("placeholder")} /></motion.div></>;
    $[7] = emitTyping;
    $[8] = isAdminOnline;
    $[9] = isAdminTyping;
    $[10] = isOpen;
    $[11] = messages;
    $[12] = sendMessage;
    $[13] = setIsOpen;
    $[14] = t;
    $[15] = visitorSessions;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  let t5;
  if ($[17] !== t4) {
    t5 = <AnimatePresence>{t4}</AnimatePresence>;
    $[17] = t4;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  return t5;
}
function _temp2(msg) {
  return <ChatMessage key={msg.id} content={msg.content} senderType={msg.senderType} createdAt={msg.createdAt} />;
}
function _temp() {
  document.body.style.overflow = "";
}
function cn(...classes: (string | boolean | undefined)[]) {
  return classes.filter(Boolean).join(" ");
}